<!--移动端帮助页面 Sag 2020-04-22-->
<template>
<div class="its-mobile-help">
  <div class="list-item-group" id="faq-topics">
      <div class="list-item" v-for="(topic, i) in topics" :key="i">
          <div class="item-title" v-on:click="fold(topic)">
              <div class="item-icon"
                    v-bind:class="{'icon-down': topic.openList, 'icon-right': topic.openList}">
                  <img class="icon icon-right"
                        :src="'images/arrow.png'"
                        width="15" height="15" style="margin-top: -3px">
              </div>
              <div class="title-section">{{topic.faqTopic.title}}</div>
          </div>
          <div v-for="(question,index) in topic.faqQuestionList" :key="index"
                @click="detail(question,index)"
                :style="{display: topic.openList ? 'block':'none'}"
                :class="['item-section',{active: index == checked }]">
              {{question.title}}
          </div>
      </div>
  </div>
  <answer v-if="showAnswer" :answer="answer" :father-action="answerAction"></answer>
</div>
  
</template>
<script>
import Answer from './components/Answer'
import {helpApi} from '../../../utils/api'
export default {
  name: 'MobileHelp',
  components: {
    Answer
  },
  data () {
    return {
      topics: [],
      checked: -1,
      oldTopic: null,
      user: {},
      answer: {},
      showAnswer: false
    }
  },
  computed: {
    loginUser: function () {
      return this.$store.state.user
    }
  },
  watch: {
    loginUser: {
      handler: function () {
        console.log(this.$store.state.user)
        this.user = this.$store.state.user
        if (this.user){
          this.getFaqs()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getFaqs: function () {
      helpApi.getFaqs(this.user.userType).then((res)=>{
        this.topics = res
        this.topics.forEach((topic)=>{
          topic.openList = false
        })
        console.log(this.topics)
      })
    },
    detail: function (question,index) {
        console.log(question, index)
        this.getAnswer(question)
    },
    fold: function (topic) {
      console.log(topic)
        this.checked = -1;
        if (this.oldTopic && topic != this.oldTopic) {
            if (this.oldTopic.openList) {
                this.oldTopic.openList = false
            }
        }
        topic.openList = !topic.openList
        this.oldTopic = topic
    },
    getAnswer: function (question) {
      helpApi.getAnswer(question.id).then((res)=>{
        console.log(res)
        this.answer = res
        this.showAnswer = true
      })
    },
    answerAction: function (data) {
      if (data.type == 'close') {
        this.showAnswer = false
      }
    }
  }
}
</script>
<style scoped>
body {
    margin: 0;
    background-color: #f5f5f5;
}
.its-mobile-help {
  position: fixed;
  z-index: 3000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #F7F4F8;
}
.list-item {
    background-color: #fff;
    margin: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.item-title {
    font-size: 15px;
    font-weight: 500;
    margin-left: 15px;
    height: 57px;
    width: 100%;
    color: #333333;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.item-title .item-icon {
    display: inline-block;
    height: 100%;
    line-height: 4;
}

.item-section {
    padding: 15px 15px 23px 34px;
    border-top: #eee 1px solid;
    background-color: #fff;
    display: none;
    color: #666666;
    font-size: 13px;
    width: 100%;
    /* width:calc(100% - 49px); */
}

.item-section:hover {
    background-color: #f5f5f5;
    color: #5591fe;
}

.active{
    background-color: #f5f5f5;
    color: #5591fe;
}

.title-section {
    margin-left: 7px;
    display: inline-block;
}

.icon-right {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    /* Internet Explorer */
    -moz-transform: rotate(180deg);
    /* Firefox */
    -webkit-transform: rotate(180deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(180deg);
    /* Opera */
    display: inline-block;
}

.icon-down {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    /* Internet Explorer */
    -moz-transform: rotate(90deg);
    /* Firefox */
    -webkit-transform: rotate(90deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(90deg);
    /* Opera */
    display: inline-block;
}
</style>